























































































import Vue from 'vue'
import { Asset, AssetGroup, AssetGroupType, AssetType } from '@/types/assets'
import './Folder.scss'
import { Drag, Drop } from 'vue-drag-drop'
import { minLength, required } from 'vuelidate/lib/validators'
import { AbilityAction, AbilitySubject } from '@/abilitiesByRole'
import { KeyDict } from '@/types'

// TODO Validator - should be same as new folder (check for existing folders in current level)
// @ts-ignore
// const inArray = (_matches = (e, v) => e === v) =>
//   function (value: any, component: any): any {
//     const sanitizedValue = value.toLowerCase()
//     const activeFolder = component.activeFolder
//     if (!activeFolder || !activeFolder.id) {
//       // @ts-ignore
//       const rootMatches = this.rootFolders.filter(folder => {
//         // @ts-ignore
//         const hasSameType = this.newAssetGroupType === folder.type
//         const hasSameName = folder.name.toLowerCase() === sanitizedValue
//         return hasSameName && hasSameType
//       })
//       return rootMatches.length === 0
//       // return true
//     }
//
//     // check in current folder
//     // @ts-ignore
//     const others = this.folderList.filter(folder => {
//       // @ts-ignore
//       const hasSameType = this.newAssetGroupType === folder.type
//       const hasSameName = folder.name.toLowerCase() === sanitizedValue
//       const hasSameParent = folder.parent_id === activeFolder.id
//       return hasSameName && hasSameType && hasSameParent
//     })
//     return others.length === 0
//   }

export default Vue.extend({
  name: 'Folder',
  props: {
    folder: {
      type: Object as () => AssetGroup
    },
    selected: {
      type: String
    },
    droppable: {
      type: Boolean,
      default: true
    },
    deletable: {
      type: Boolean,
      default: true
    },
    inCast: {
      type: Boolean,
      required: true
    },
    isParent: {
      type: Boolean,
      default: false
    }
  },
  validations: {
    folderName: {
      required,
      minLength: minLength(2),
      // noDouble: inArray() //TODO same as with new Folder creation
    }
  },
  // watch: {
  //   folder (newValue: AssetGroup) {
  //     this.folderName = newValue.name
  //     console.log('watch folder ', newValue)
  //   }
  // },
  computed: {
    // note: the root folder is a virtual folder that is not saved to db
    isRootFolder (): boolean {
      return !this.folder.parent_id
    },
    allfolders (): KeyDict<AssetGroup> {
      return this.$store.direct.state.assets.folderList
    },
    deleteFolderVisible (): boolean {
      return !this.editMode && !this.inCast && this.$can(AbilityAction.Delete, AbilitySubject.AssetGroups)
    },
    canEditFolder (): boolean {
      return this.$can(AbilityAction.Edit, AbilitySubject.AssetGroups)
    },
    open (): boolean {
      let open = false
      if (this.folder !== null && this.folder !== undefined) {
        const id = this.folder.id
        open = this.selected === id
      }
      return open
    },
    name (): string {
      let name = ''
      if (this.folder && this.folder.name) {
        name = this.folder.name

        const socialMediaType = this.socialMediaType
        const isChat = socialMediaType.indexOf('chat') > -1
        if (this.isSocialMedia && !isChat) {
          const prefix = (socialMediaType.indexOf('hashtag') > -1) ? '#' : '@'
          name = prefix + name
        }
      }
      return name
    },
    icon (): string {
      let icon = 'folder'
      if (this.open) {
        icon = 'folder-open'
      }

      const socialMediaType = this.socialMediaType
      if (socialMediaType) {
        switch (socialMediaType) {
          case AssetGroupType.TwitterHashtag:
          case AssetGroupType.TwitterHandle:
            icon = 'brands/twitter'
            break
          case AssetGroupType.InstagramHashtag:
          case AssetGroupType.InstagramHandle:
            icon = 'brands/instagram'
            break
          case AssetGroupType.YouTubeChat:
            icon = 'brands/youtube'
            break
          case AssetGroupType.FacebookChat:
            icon = 'brands/facebook'
            break
        }
      }
      return icon
    },
    isSocialeMediaChat (): boolean {
      return !!this.folder && !!this.folder.type && this.folder.type.indexOf('chat') > -1
    },
    isSocialMedia (): boolean {
      const isSocialMedia = this.folder && this.folder.type && (this.folder.type.indexOf('hashtag') > -1 || this.folder.type.indexOf('handle') > -1 || this.isSocialeMediaChat)
      return !!isSocialMedia
    },
    socialMediaType (): AssetGroupType {
      return (this.isSocialMedia && this.folder.type) ? this.folder.type : AssetGroupType.Unknown
    },
    invalidFolderNameError (): string {
      return this.$v.folderName?.$invalid ? 'Folder name must be at least 2 characters': ''
    }
  },
  created () {
    this.folderName = this.folder.name
  },
  // mounted () {
  //
  // },
  data: () => ({
    list: [],
    editMode: false,
    folderName: '',
    dragging: false,
    dragover: false,
    canDropType: false,
    allowedGroupTypes: [
      AssetGroupType.Folder,
      AssetGroupType.TwitterHandle
      // ...more...
    ],
    allowedAssetTypes: [
      AssetType.Graphic,
      AssetType.Video,
      AssetType.Widget,
      AssetType.TweetPoll
    ]
  }),
  methods: {
    handleDragStart () {
      console.log('handleDragStart isParent ', this.isParent)
      if (this.editMode || this.isParent) {
        return false
      }

      this.dragging = !!this.folder
    },
    handleDrop (data) {
      this.dragover = false
      if (!data || !this.canDropType) {
        return
      }

      const asset: Asset = data.asset
      const folder: AssetGroup = data.folder

      if (asset) {
        this.fileAdded(asset)
      } else {
        this.folderAdded(folder)
      }
      console.log(`You dropped with data: ${JSON.stringify(data)}`);
    },
    handleDragover (data: any, event: any) {
      if (!data) {
        return
      }

      const asset: Asset = data.asset
      const draggingFolder: AssetGroup = data.folder
      const dropFolder = this.folder
      this.dragover = true

      const isRootFolder = this.isRootFolder
      const isAllowedAssetType = asset && this.allowedAssetTypes.some(t => t === asset.type)
      const isAllowedFolderType = !!draggingFolder && (isRootFolder || this.folder.type === AssetGroupType.Folder)
      const isSelf = draggingFolder && draggingFolder.id === this.folder.id
      let isDescendant = false
      if (isAllowedFolderType) {
        const descendantFolders = this._allDescendantFolders(draggingFolder, [])
        isDescendant = isAllowedFolderType && descendantFolders.some(d => d.id === dropFolder.id)
      }

      // not allowed to drop assets on root folder (does not have an id)
      // or drop a folder onto itself or a descendant folder of itself
      // or drop anything on a social media folder
      if (isSelf || (isRootFolder && !isAllowedFolderType) || isDescendant || this.isSocialMedia) {
        this.canDropType = false
        return
      }

      this.canDropType = isAllowedAssetType || isAllowedFolderType

      if (!this.canDropType) {
        event.dataTransfer.dropEffect = 'none'
      } else {
        event.dataTransfer.dropEffect = 'move'
      }
    },
    _allDescendantFolders (folder: AssetGroup, result: AssetGroup[]): AssetGroup[] {
      const folderId = folder.id || ''
      if (!folderId) {
        return result
      }
      let currentFolderResult:AssetGroup[] = []
      const childFolders = Object.values(this.allfolders).filter(f => f.parent_id === folderId)
      childFolders.forEach((childFolder: AssetGroup) => {
        currentFolderResult.push(childFolder)
        currentFolderResult = this._allDescendantFolders(childFolder, currentFolderResult)
      })
      return result.concat(currentFolderResult)
    },
    openFolder (): void {
      if (this.editMode) {
        return
      }

      this.$emit('open', this.folder)
    },
    changeMode (ev: Event): void {
      ev.stopPropagation()
      ev.preventDefault()

      this.editMode = !this.editMode
      if (this.editMode === true) {
        setTimeout(() => {
          const input = this.$refs.foldername as HTMLInputElement|undefined
          if (input) {
            input.focus()
          }
        }, 400)
      } else {
        this.folderName = this.folder.name
      }
    },
    saveName (ev: Event): void {
      ev.stopPropagation()
      ev.preventDefault()

      const folder = { ...this.folder }
      folder.name = this.folderName

      this.$store.direct.dispatch.assets.updateFolderName(folder).then(() => {
        this.$message({
          type: 'success',
          message: `${this.folderTypeText(folder)} renamed to "${folder.name}"`
        })
      }).catch(error => {
        console.error('updateFolderName', error)
      })

      this.editMode = false
    },
    folderTypeText (folder): string {
      if (folder && folder.type && folder.type.length > 1) {
        if (folder.type.indexOf('chat') > -1) {
          return 'Live Chat'
        }
        return folder.type.charAt(0).toUpperCase() + folder.type.slice(1)
      } else {
        return 'Folder'
      }
    },
    fileAdded (asset: Asset): void {
      if (asset.type === AssetType.Tweet) {
        return
      }

      const assetProperties: Partial<Asset> = {
        id: asset.id,
        asset_group: this.folder.id
      }

      this.$store.direct.dispatch.assets.updateAsset(assetProperties)
        .then(() => {
          this.$message({
            type: 'success',
            message: `${asset.name} has been moved to "${this.folder.name}"`
          })
      }).catch(error => {
        console.error('folderDrop error', error)
      })
    },
    folderAdded (folder: AssetGroup): void {
      const isSelf = folder.id === this.folder.id
      if (isSelf) {
        // avoid dropping a folder onto itself by accident
        console.log('do not drop folder onto itself')
        return
      }

      const folderProperties: Partial<AssetGroup> = {
        id: folder.id,
        parent_id: this.folder.id
      }

      // console.log('folderAdded folderProperties ', folderProperties)
      // console.log('folderAdded dragged into ', this.folder.name)

      this.$store.direct.dispatch.assets.updateAssetGroup(folderProperties)
        .then(() => {
          const folderName = (this.isRootFolder) ? 'top level' : `"${this.folder.name}"`
          this.$message({
            type: 'success',
            message: `${folder.name} has been moved to ${folderName}`
          })
        }).catch(error => {
        console.error('folderDrop error', error)
      })
    },
    unlinkFolder (): void {
      this.$store.direct.dispatch.events.removeAssetGroupFromCast(this.folder.id)
    },
    removeFolder (): void {
      this.$store.direct.dispatch.assets.deleteAssetFolder({ folder: this.folder, deepDelete:true })
    },
    deleteFolder (ev: Event): void {
      ev.stopPropagation()
      ev.preventDefault()

      if (this.inCast) {
        let question = 'Are you sure you want to remove this folder from cast?'
        if (this.folder.type && [AssetGroupType.TwitterHashtag, AssetGroupType.InstagramHashtag].includes(this.folder.type)) {
          question = 'Are you sure you want to remove this hashtag from cast?'
        }
        if (this.folder.type && [AssetGroupType.TwitterHandle, AssetGroupType.InstagramHandle].includes(this.folder.type)) {
          question = 'Are you sure you want to remove this handle from cast?'
        }
        this.$confirm(question, 'Warning', {
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          type: 'warning'
        }).then(() => {
          this.unlinkFolder()
        }).catch(() => {})
      } else {
        let question = 'Are you sure you want to delete this folder? NOTE: This will also delete the assets & subfolders it contains. This action cannot be undone.'
        if (this.folder.type === 'hashtag') {
          question = 'Are you sure you want to delete this hashtag?'
        }
        if (this.folder.type === 'handle') {
          question = 'Are you sure you want to delete this handle?'
        }
        this.$confirm(question, 'Warning', {
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          type: 'warning'
        }).then(() => {
          this.$emit('deleteFolder', this.folder)
        }).catch(() => {})
      }
    }
  },
  components: {
    // draggable
    Drag,
    Drop,
  }
})
